import React, {useEffect, useState, useContext, Fragment} from 'react';
import {useTranslate} from 'react-polyglot';

import AppContext from '../../components/app/AppContext';
import ExperienceService from '../../services/Experience';
import FilterBy from '../../components/Filters/FilterBy';
import {MigrateUserDialogContext} from "../../context/MigrateExperienceUserDialogContext";
import {QRDialogContext} from "../../context/QRDialogContext";
import {ChangeTargetDialogContext} from "../../context/ChangeTargetDialogContext";
import {ChangeNameDialogContext} from "../../context/ChangeNameDialogContext";
import { CardHomeStudio } from '../../pages/Home/CardHomeStudio';
import Loading from '../../components/loading';
import ShowLoadingContext from '../../context/ShowLoadingContext';

function Recent() {
    const context = useContext(AppContext);
    const [experiences, setExperiences] = useState([])
    const t = useTranslate();

    const { 
        showLoading,
        setShowLoading,
        overlayStyle, 
        setOverlayStyle,
    } = useContext(ShowLoadingContext)

 

    const fetchData = async () => {
        setShowLoading(true)
        setOverlayStyle("loading-overlay-projects")
        const {data} = await ExperienceService.recent();
        setExperiences(data || []);
        setShowLoading(false)
    }

    useEffect(() => {
        context.setPage({
            name: t('pages.recent.recentExp'),
            refetch: fetchData
        });
        fetchData();
    }, [])
    const {MigrationUserExperienceDialog} = useContext(MigrateUserDialogContext);
    const {QRDialog} = useContext(QRDialogContext);
    const {ChangeTargetDialog} = useContext(ChangeTargetDialogContext);
    const {
        ChangeNameDialogComponent
    } = useContext(ChangeNameDialogContext);
    return (
        <Fragment>
            {QRDialog()}
            {MigrationUserExperienceDialog()}
            {ChangeTargetDialog()}
            {ChangeNameDialogComponent()}
            {showLoading && 
                <Loading/>
            }
            <FilterBy data={experiences} typeData="experiences">
                {result => (
                    <div className={'campaign-container'}>
                        {result.map(exp => <CardHomeStudio key={exp.id} experienceCardStyle={'campaign-exp-card'} experience={exp}/>)}

                    </div>
                )}
            </FilterBy>
        </Fragment>
    );
}

export default Recent;
